import { StaticImage } from 'gatsby-plugin-image'
import React, { useContext } from 'react'

import * as styles from './DownloadBambooApp.module.scss'
import iOSAppStore from '../../assets/new-icons/AppBadges_Apple.svg'
import AndroidAppStore from '../../assets/new-icons/AppBadges_Google.svg'
import {
  ANDROID_DOWNLOAD_PRESS,
  IOS_DOWNLOAD_PRESS,
} from '../../constants/analytics'
import {
  ANDROID_DOWNLOAD_PRESS_FB,
  IOS_DOWNLOAD_PRESS_FB,
} from '../../constants/facebookPixel'
import { RegionContext } from '../../context/region-context'
import { facebookPixelCustomEvent } from '../../services/facebook-pixel'
import { logEvent } from '../../services/firebase/analytics'

const ANDROID_DOWNLOAD_LINK =
  'https://play.google.com/store/apps/details?id=ch.bamboocore.app&hl=en'
const IOS_DOWNLOAD_LINK =
  'https://apps.apple.com/au/app/bamboo-effortless-investment/id1386681221'
const US_BUTTON_LINK = 'https://getbamboo.typeform.com/to/fspr14Qu'

function DownloadBambooApp() {
  const region = useContext(RegionContext)

  const handleDownloadIosClick = () => {
    logEvent(IOS_DOWNLOAD_PRESS)
    facebookPixelCustomEvent(IOS_DOWNLOAD_PRESS_FB)
  }
  const handleDownloadAndroidClick = () => {
    logEvent(ANDROID_DOWNLOAD_PRESS)
    facebookPixelCustomEvent(ANDROID_DOWNLOAD_PRESS_FB)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.desktopContent}>
        <div className={styles.textContent}>
          <h2 className={styles.title}>Download bamboo app</h2>
          <h4 className={styles.subtitle}>
            Scan this QR code with your camera to download the app.
          </h4>
        </div>
        <div className={styles.qrCode}>
          <div>
            <StaticImage
              src="../../assets/images/download-qr.png"
              alt="Bamboo app download qr code"
              width={200}
              quality={100}
            />
          </div>
        </div>
      </div>
      <div className={styles.mobileContent}>
        <h2 className={styles.mobileTitle}>Download bamboo app</h2>
        <div className={styles.downloadLinks}>
          <a
            href={region.isUSRegion ? US_BUTTON_LINK : IOS_DOWNLOAD_LINK}
            target=" _new"
            title="Download Bamboo investment iOS App"
            onClick={handleDownloadIosClick}
            className={styles.appDownloadLink}
          >
            <img
              alt="Bamboo investment iOS App"
              src={iOSAppStore}
              width="135"
              height="40"
              loading="lazy"
            />
          </a>
          <a
            href={region.isUSRegion ? US_BUTTON_LINK : ANDROID_DOWNLOAD_LINK}
            target=" _new"
            title="Download Bamboo investment Android App"
            onClick={handleDownloadAndroidClick}
            className={styles.appDownloadLink}
          >
            <img
              alt="Bamboo investment Android App"
              src={AndroidAppStore}
              width="135"
              height="40"
              loading="lazy"
            />
          </a>
        </div>
      </div>
      <div className={styles.background} />
    </div>
  )
}

export default DownloadBambooApp
